<template>
    <a-drawer :title="title" width="600" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="组织详情" bordered :column="1" size="middle">
            <a-descriptions-item label="组织名称">
                {{ item.name }}
            </a-descriptions-item>
            <a-descriptions-item label="标签内容">
                {{ item.tags }}
            </a-descriptions-item>
            <a-descriptions-item label="组织类型">
                {{ item.type | fmtTeamType }}
            </a-descriptions-item>
            <a-descriptions-item label="负责人">
                {{ item.link }}
            </a-descriptions-item>
            <a-descriptions-item label="个人申请">
                {{ item.ma ? '支持' : '不支持' }}
            </a-descriptions-item>
            <a-descriptions-item label="心理师申请">
                {{ item.ca ? '支持' : '不支持' }}
            </a-descriptions-item>
            <a-descriptions-item label="机构申请">
                {{ item.ua ? '支持' : '不支持' }}
            </a-descriptions-item>
            <a-descriptions-item label="组织宗旨">
                {{ item.aim }}
            </a-descriptions-item>
            <a-descriptions-item label="组织简介">
                {{ item.memo }}
            </a-descriptions-item>
            <a-descriptions-item label="主要活动">
                {{ item.act }}
            </a-descriptions-item>
            <a-descriptions-item label="活动周期">
                {{ item.cycle }}
            </a-descriptions-item>
            <a-descriptions-item label="活动形式">
                {{ item.info }}
            </a-descriptions-item>
            <a-descriptions-item label="项目名称">
                {{ item.pro }}
            </a-descriptions-item>
            <a-descriptions-item label="指导单位">
                {{ item.unit }}
            </a-descriptions-item>
            <a-descriptions-item label="秘书处">
                {{ item.mgr }}
            </a-descriptions-item>
            <a-descriptions-item label="获得荣誉">
                {{ item.honor }}
            </a-descriptions-item>
        </a-descriptions>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    }
}
</script>
